'use strict';


var nodeMap = require('../node.map.js'),
    listItemRender = require('./list.item');


module.exports = function ( value, callback ) {
    var self = this;

    listItemRender.call(this, null, function () {
        nodeMap.data[self.id].onclick = function () {
            require('../utils/confirm')(self.confirmation.title, function ( result ) {
                self.confirmation.callback.call(self, result);
            });
        };
    });

    callback();
};
